import styled from 'styled-components';

const DeleteConfirmDialogWrapper = styled.div`
    width: 100%;
    font-family: 'Zen Kaku Gothic Antique';
`;

export default DeleteConfirmDialogWrapper;
